import React from "react"
import * as Sentry from "@sentry/react"
import { connect } from "react-redux"
import { get_current_user } from "./actions"
import { login_failed, login_successful } from "./actions/auth"
import LoadingIndicator from "./components/loading-indicator"
import Rmbx from "./util"
import * as qs from "qs"
import { setCookie } from "./common/ts-utils"
import { getAuthToken } from "./util"
import { getFlagEnabled } from "./getFlagValue"
import { AUTH_EXPIRY } from "./common/constants"

class SsoRedirectHandler extends React.Component {
    componentDidMount() {
        if (this.props.location.pathname === "/rhumbix/sso-mobile-callback/") {
            window.location.replace(`rhumbix://sso-callback/?${this.props.location.hash}`)
        } else {
            const idToken = this.handleSsoProvider()

            if (idToken) {
                if (getFlagEnabled("WA-7694-cookies-for-auth")) {
                    setCookie("token", idToken, "/", AUTH_EXPIRY)
                    setCookie("authorization_type", "Bearer", "/", AUTH_EXPIRY)
                } else {
                    Rmbx.store.set("token", idToken)
                    Rmbx.store.set("authorization_type", "Bearer")
                }
                // finally get the user and finish the login flow
                this.props.dispatch(get_current_user())
            }
        }
    }

    handleSsoCallbackFailure = failureMessage => {
        this.props.dispatch(login_failed(failureMessage))
        Rmbx.util.history.push("/rhumbix/login/")
    }

    handleSsoProvider = () => {
        // for any other sso provider following an openid connect hybrid flow
        if (this.props.location.hash) {
            const qsParams = qs.parse(this.props.location.hash, { ignoreQueryPrefix: true })
            if ("#id_token" in qsParams) {
                return qsParams["#id_token"]
            }
            if ("id_token" in qsParams) {
                return qsParams["id_token"]
            }
        }
        this.handleSsoCallbackFailure("Failed to login. Could not process SSO callback hash.")
        return null
    }

    render() {
        if (this.props.currentUser && this.props.currentUser.employee) {
            Sentry.configureScope(scope =>
                scope.setUser({
                    email: this.props.currentUser.email,
                    id: this.props.currentUser.employee.id,
                })
            )
            this.props.dispatch(
                login_successful({
                    token: getAuthToken(),
                    user: this.props.currentUser,
                })
            )
            Rmbx.util.history.push("/rhumbix/")
        }
        return (
            <div>
                <LoadingIndicator active={true} />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        currentUser: state.current_user,
    }
}

export default connect(mapStateToProps)(SsoRedirectHandler)
